export default {
  title: 'Account Suspended',
  description:
    'Your account has been temporarily suspended. This may be due to a violation of our terms of service or unusual activity. Please contact our support team to resolve this.',
  contactLabel: 'Reach our support team',
  emailSubject: 'Account Suspension — Help Request',
  emailHint: 'We typically respond within 24 hours',
  note: 'Please include your registered email address when contacting support.',
  logout: 'Sign out',
};